import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { PrimaryButton } from 'src/components/common/buttons/PrimaryButton';
import { ICreateDownloadJobSuccessModalProps } from 'src/features/job/domain/types';

const CreateDownloadJobSuccessModal: React.FC<
	ICreateDownloadJobSuccessModalProps
> = ({ isModalOpen, handleModalClose, newJob }) => {
	const handleClose = () => {
		handleModalClose();
	};

	const message = (
		<Typography
			sx={{
				fontSize: '16px',
				color: '#000000DE',
				letterSpacing: '0.15px',
				lineHeight: '24px',
			}}
		>
			Download job created for {newJob.total_patients} patients
			{newJob.selected_date_range ? (
				<>
					{' within '}
					<strong>{newJob.selected_date_range}</strong>
					{' date range.'}
				</>
			) : (
				'.'
			)}
		</Typography>
	);

	return (
		<Dialog
			PaperProps={{
				sx: {
					width: '610px',
					height: '200px',
				},
			}}
			open={isModalOpen}
			onClose={handleClose}
		>
			<DialogTitle>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'baseline',
					}}
				>
					<Typography
						sx={{
							fontSize: '20px',
							color: '#000000DE',
							letterSpacing: '0.15px',
							lineHeight: '32px',
							fontWeight: 700,
						}}
					>
						Create Download Job Success
					</Typography>
					<IconButton onClick={handleClose}>
						<CloseIcon
							fontSize='small'
							sx={{ color: '#000000DE', fontWeight: 500 }}
						/>
					</IconButton>
				</Box>
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: '0', flex: 1 }}>
				{message}
			</DialogContent>
			<DialogActions sx={{ paddingBottom: '24px', paddingRight: '24px' }}>
				<PrimaryButton
					variant='contained'
					size='small'
					sx={{
						fontSize: '15px',
						fontWeight: 700,
					}}
					onClick={handleClose}
				>
					Continue
				</PrimaryButton>
			</DialogActions>
		</Dialog>
	);
};

export default CreateDownloadJobSuccessModal;
